import awsdk from 'awsdk';

// PROVIDER
// CONSUMER
// ASSISTANT

export const UserType = awsdk.AWSDKUserType;
export type UserType = typeof UserType;
